import { render, staticRenderFns } from "./ConsommationServices.vue?vue&type=template&id=b2af6f06&scoped=true&"
import script from "./ConsommationServices.vue?vue&type=script&lang=js&"
export * from "./ConsommationServices.vue?vue&type=script&lang=js&"
import style0 from "./ConsommationServices.vue?vue&type=style&index=0&id=b2af6f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2af6f06",
  null
  
)

export default component.exports